import { Action, State, StateContext, Store } from "@ngxs/store";
import { SchoolServiceData } from "../models/school-service-data.model";
import { Injectable } from "@angular/core";
import { AlertService } from "src/app/shared/store/alert/alert.service";
import { LocalizationService } from "src/app/services/localization/localization.service";
import { SchoolServiceActions } from "./school-service.actions";
import { SchoolServiceService } from "../services/school-service.service";
import { patch } from "@ngxs/store/operators";
import * as moment from 'moment';
import { MappingUtilsService } from "src/app/services/utils/mapping-utils.service";

export class SchoolServiceStateModel {
  schoolServiceAddForm: {
    model: SchoolServiceData
  }
  public isLoadingSchoolServices: boolean;
  public error: string;
}

const defaults = {
  schoolServiceAddForm: {
    model: null
  },
  isLoadingSchoolServices: false,
  error: null
};

@State<SchoolServiceStateModel>({
  name: 'schoolServices',
  defaults,
})
@Injectable()
export class SchoolServiceState {
  constructor(
    private alertService: AlertService,
    private localizationService: LocalizationService,
    private schoolServicesService: SchoolServiceService,
    public store: Store
  ) {}

  @Action(SchoolServiceActions.AddSchoolService)
  addSchoolService(ctx: StateContext<SchoolServiceStateModel>, {schoolService, user}: SchoolServiceActions.AddSchoolService) {
    this.alertService.confirm(
      this.localizationService.translate("labels.school"),
      this.localizationService.translate('school-services.schoolServiceAddConfirm'),
      this.localizationService.translate('buttons.accept'),
      this.localizationService.translate('buttons.cancel'),
      this.localizationService.translate('school-services.schoolServiceAddConfirm')
    ).then((result) => {
      if (result.value) {
        ctx.patchState({isLoadingSchoolServices: true});
        schoolService = this.getSchoolServiceResponse(schoolService);
        return this.schoolServicesService.createSchoolService(schoolService, user).subscribe({
          next: (res) => ctx.dispatch(new SchoolServiceActions.AddSchoolServiceSuccess(schoolService)),
          error: (error) => {
            ctx.dispatch(new SchoolServiceActions.Error(error));
          }
        });
      } else {
        return null;
      }
    });
  }

  @Action(SchoolServiceActions.AddSchoolServiceSuccess)
  addSchoolServiceSuccess(ctx: StateContext<SchoolServiceStateModel>, {schoolService}: SchoolServiceActions.AddSchoolServiceSuccess) {
    ctx.setState(
      patch({
        isLoadingSchoolServices: false
      })
    );
  }

  @Action(SchoolServiceActions.EditSchoolService)
  editSchoolService(ctx: StateContext<SchoolServiceStateModel>, {schoolService, user}: SchoolServiceActions.EditSchoolService) {
    this.alertService.confirm(
      this.localizationService.translate("labels.school"),
      this.localizationService.translate('school-services.schoolServiceEditConfirm'),
      this.localizationService.translate('buttons.accept'),
      this.localizationService.translate('buttons.cancel'),
      this.localizationService.translate('school-services.schoolServiceEditConfirm')
    ).then((result) => {
      if (result.value) {
        ctx.patchState({isLoadingSchoolServices: true});
        schoolService = this.getSchoolServiceResponse(schoolService);
        return this.schoolServicesService.updateSchoolService(schoolService, user).subscribe({
          next: (res) => ctx.dispatch(new SchoolServiceActions.EditSchoolServiceSuccess(schoolService)),
          error: (error) => {
            ctx.dispatch(new SchoolServiceActions.Error(error));
          }
        });
      } else {
        return null;
      }
    });
  }

  @Action(SchoolServiceActions.EditSchoolServiceSuccess)
  editSchoolServiceSuccess(ctx: StateContext<SchoolServiceStateModel>, {schoolService}: SchoolServiceActions.EditSchoolServiceSuccess) {
    ctx.setState(
      patch({
        isLoadingSchoolServices: false
      })
    );
  }

  @Action(SchoolServiceActions.SetSchoolServicesDefaultState)
  setSchoolsDefaultState(ctx: StateContext<SchoolServiceStateModel>, {}: SchoolServiceActions.SetSchoolServicesDefaultState) {
    ctx.patchState(
      defaults
    );
  }

  @Action(SchoolServiceActions.SetSchoolServicesAddFormDefaultState)
  setSchoolServicesAddFormDefaultState(ctx: StateContext<SchoolServiceStateModel>, {}: SchoolServiceActions.SetSchoolServicesAddFormDefaultState) {
    ctx.setState(
      patch({
        schoolServiceAddForm: patch({
          model: null
        })
      })
    );
  }

  @Action(SchoolServiceActions.Error)
  onErrorOcurred(ctx: StateContext<SchoolServiceStateModel>, { error }: SchoolServiceActions.Error) {
    ctx.patchState({
      error: error,
      isLoadingSchoolServices: false,
    });
    MappingUtilsService.showError(this.getTitle(), error, this.alertService, this.localizationService);
  }

  getSchoolServiceResponse(schoolService: SchoolServiceData): SchoolServiceData {
    let schoolServiceResponse = {...schoolService};
    schoolServiceResponse.startDate = new Date(moment(schoolServiceResponse.startDate).format('YYYY-MM-DD'));
    schoolServiceResponse.endDate = new Date(moment(schoolServiceResponse.endDate).format('YYYY-MM-DD'));
    return schoolServiceResponse;
  }

  private getTitle() {
    return this.localizationService.translate('labels.schoolServices');
  }
}
